import React from 'react';

const TIER_CONFIG = {
  0: { label: 'T0', bg: 'bg-red-100', text: 'text-red-700', ring: 'ring-red-200' },
  1: { label: 'T1', bg: 'bg-orange-100', text: 'text-orange-700', ring: 'ring-orange-200' },
  2: { label: 'T2', bg: 'bg-yellow-100', text: 'text-yellow-700', ring: 'ring-yellow-200' },
  3: { label: 'T3', bg: 'bg-blue-100', text: 'text-blue-700', ring: 'ring-blue-200' },
  4: { label: 'T4', bg: 'bg-gray-100', text: 'text-gray-600', ring: 'ring-gray-200' },
};

export default function TierBadge({ tier }) {
  if (tier === null || tier === undefined) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-50 text-gray-400 ring-1 ring-gray-200">
        —
      </span>
    );
  }

  const config = TIER_CONFIG[tier] || TIER_CONFIG[4];

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ring-1 ${config.bg} ${config.text} ${config.ring}`}>
      {config.label}
    </span>
  );
}
